import doRequest from "services/helpers";
import { getToken } from "services/auth/tokenAuth";

const parseCertificationSignatureType = item => ({
	id: Number(item?.id) || 0,
	code: item?.code || "",
	name: item?.name || "",
	hierarchyWeight: Number(item?.hierarchyWeight) || 0,
	requiresSpeakerData: Boolean(item?.requiresSpeakerData),
});

const parseAvailableCertificationSignature = item => ({
	eventSignatureId: Number(item?.eventSignatureId) || 0,
	signatureTypeId: Number(item?.signatureTypeId) || 0,
	signatureTypeCode: item?.signatureTypeCode || "",
	displayName: item?.displayName || "",
	utpCode: item?.utpCode || "",
	hierarchyWeight: Number(item?.hierarchyWeight) || 0,
	validFrom: item?.validFrom || null,
	validTo: item?.validTo || null,
	campusIds: Array.isArray(item?.campusIds) ? item.campusIds : [],
});

const formatEventEndDate = eventEndDate => {
	if (!eventEndDate) return "";
	const date = new Date(eventEndDate);
	const year = date.getFullYear();
	const month = `${date.getMonth() + 1}`.padStart(2, "0");
	const day = `${date.getDate()}`.padStart(2, "0");
	return `${year}-${month}-${day}`;
};

export const requestGetCertificationSignatureTypes = async () => {
	const [result, err] = await doRequest(
		"/Evento/Firma/Tipos",
		"GET",
		null,
		getToken()
	);
	if (err) return [];
	const { data } = result;
	if (data?.state !== 1 || !Array.isArray(data?.data)) return [];
	return data.data.map(parseCertificationSignatureType);
};

export const requestGetAvailableCertificationSignaturesByCampus = async ({
	campusId,
	eventEndDate,
}) => {
	if (!campusId || !eventEndDate) return [];
	const formattedEventEndDate = formatEventEndDate(eventEndDate);
	const endpoint =
		`/Evento/Firma/Disponibles?campusId=${campusId}&eventEndDate=${formattedEventEndDate}`;
	const [result, err] = await doRequest(endpoint, "GET", null, getToken());
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1 || !Array.isArray(data?.data)) return null;
	return data.data.map(parseAvailableCertificationSignature);
};
